module.exports = __webpack_public_path__ + "img/EMT-CECA_10X_CC.def8ee48.png";